import { Flex } from '@chakra-ui/layout';
import React from 'react';
import { Navigate, useParams } from 'react-router';

import { z } from 'zod/v4';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { TapeBuilderForImplementation } from '~/packages/tapeBuilder/ui/TapeBuilderForImplementation';

// Types
const RouteParamsStruct = z.object({
  implementationId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const params = useParams();
  const { implementationId } = RouteParamsStruct.parse(params);

  return (
    <TapeBuilderForImplementation
      implementationId={implementationId}
      implementationRoutePrefix="/implementations/"
    />
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/" />;
    }}
  >
    <Flex direction="column" padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      <RouteBase />
    </Flex>
  </RouteErrorBoundary>
);
